export const medicalActions = {
    SAVE_SELECT_BTN: "SAVE_SELECT_BTN"
}

export const educationActions = {
    SAVE_TEACHER: "SAVE_TEACHER"
}

export const authAction = {
    SAVE_USER: "SAVE_USER",
    REMOVE_USER: "REMOVE_USER"
}

export const cartAction = {
    UPDATE_CART: "UPDATE_CART",
    CLEAR_CART: "CLEAR_CART",
    REMOVE_CART: "REMOVE_CART",
    UPDATE_FULL_CART: "UPDATE_FULL_CART"
}